import type { FmProductSectionDescriptor } from '@/components/ui/FmProductPage';
import type { Language } from '@/i18n';

export function measurementSection(locale: Language): FmProductSectionDescriptor {
  const finnish = locale === 'fi';
  const title = finnish
    ? 'Omat mittaukset. Tarkempi suunnitelma.'
    : 'Your measurements. A more precise plan.';
  return {
    id: 'landing-measurement-decision-basis',
    capability: 'registered-media',
    mediaKind: 'image',
    presentation: 'balanced-media-first',
    role: 'lead',
    title,
    state: { status: 'ready' },
    answer: title,
    explanation: finnish
      ? 'Puiden läpimitat kertovat rakenteesta, joka jää keskilukujen taakse. Vertaa suunnitelmavaihtoehtoja omilla mittauksillasi tarkennettujen lähtötietojen pohjalta.'
      : 'Tree diameters reveal structure that averages leave hidden. Compare planning alternatives using inputs refined with your own measurements.',
    facts: [
      {
        id: 'measurement-inputs',
        label: finnish ? 'Tuo omat mittauksesi' : 'Bring your own measurements',
        value: finnish ? 'Käsin, sovelluksesta tai tiedostona' : 'Manually, from an app or a file',
      },
    ],
    caption: finnish
      ? 'Puhelin mukaan maastoon. Kuvituskuva.'
      : 'Take your phone into the field. Editorial photograph.',
    mediaIdentity: 'product.measurement-field-photo',
  };
}
